function tryConversionToE164Format(input = '') {
  const digits = input.replace(/\D/g, '');

  let convertedInput = '';

  if (digits.length === 11 && digits.startsWith('1')) {
    convertedInput = '+' + digits;
  } else if (digits.length === 10) {
    convertedInput = '+1' + digits;
  } else {
    convertedInput = '';
  }

  if (/^\+1\d{10}$/.test(convertedInput)) {
    return convertedInput;
  } else {
    return; // fail silently
  }
}

export default tryConversionToE164Format;
